import type { ReactElement } from "react";
import { mystic } from "../palette";

interface IDividerProps {
  children: any;
}

export default function Divider({ children }: IDividerProps): ReactElement {
  return (
    <div
      css={{
        display: "grid",
        gridTemplateColumns: "1fr max-content 1fr",
        alignItems: "center",
        gridColumnGap: 12,
        userSelect: "none",
      }}
    >
      <div
        css={{
          width: "100%",
          height: 1,
          borderBottom: `solid 1px ${mystic}`,
        }}
      />

      <div>{children}</div>

      <div
        css={{
          width: "100%",
          height: 1,
          borderBottom: `solid 1px ${mystic}`,
        }}
      />
    </div>
  );
}
